// Copyright (c) BSS-ONE
// Author: Alexandru Bagu (a.bagu at software-dep.net)

<template>
  <a-spin :spinning="loading">
    <table-view
      :columns="columns"
      :data="rows"
      size="small"
      rowKey="id" />
    <a-modal
      :title="this.$t('label.workspaces.user.password')"
      :visible="userPasswordModalVisible"
      @ok="updateUserPassword"
      @cancel="closeUserPasswordModal">
      <a-form
        :ref="(el) => { this.form_ref = el; }"
        :model="update"
        :rules="form_rules"
        layout="vertical">
        <a-row><a-col :xl="24">
          <a-form-item :label="this.$t('label.password')" name="password">
            <a-input
              v-model:value="update.password"
              type="password" />
          </a-form-item>
        </a-col></a-row>
        <a-row><a-col :xl="24">
          <a-form-item :label="this.$t('label.confirmpassword')" name="confirmpassword">
            <a-input
              v-model:value="update.confirmpassword"
              type="password" />
          </a-form-item>
        </a-col></a-row>
      </a-form>
    </a-modal>
  </a-spin>
</template>

<script>
import { mixinDevice } from '@/utils/mixin.js'
import Status from '@/components/widgets/Status'
import TableView from '@/components/view/TableView'
import _ from 'lodash'
import { reactive, h } from 'vue'
import AnsibleMixin from './AnsibleMixin'
import { Tooltip, Button } from 'ant-design-vue'
import { MoreOutlined, DeleteOutlined, DesktopOutlined, TeamOutlined, UserOutlined, KeyOutlined } from '@ant-design/icons-vue'

export default {
  name: 'WorkspaceUsers',
  components: {
    Status,
    TableView
  },
  mixins: [mixinDevice, AnsibleMixin],
  props: {
    workspaceId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      isAdmin: false,
      columns: [],
      rows: [],
      loading: true,
      hasInit: false,
      virtualmachines: [],
      resource: {},
      update: {
        user: {},
        password: '',
        confirmpassword: ''
      },
      userPasswordModalVisible: false
    }
  },
  created () {
    this.isAdmin = this.isAdminRole()
  },
  mounted () {
    this.init(h)
  },
  watch: {
    workspaceId: function () {
      this.fetchData()
    }
  },
  methods: {
    init (h) {
      var that = this
      this.columns = [{
        dataIndex: 'name',
        title: this.$t('label.name'),
        customRender: function ({ text, record, index }) {
          if (record.status !== 'READY') {
            if (that.isAdmin) {
              return <span>
                <span>{text}</span>
                <span style="float: right">
                  {h(Tooltip, { placement: 'top', overlayStyle: { 'z-index': 0 } }, {
                    title: () => <div>
                      {h(Tooltip, { placement: 'bottom' }, {
                        title: () => <span>{record.vmUuid ? that.$t('label.workspace.user.delete') : that.$t('label.workspace.user.simple.delete')}</span>,
                        default: () => h(Button, {
                          shape: 'circle',
                          type: 'danger',
                          style: { 'margin-right': '2px' },
                          onClick: () => that.deleteUser(record)
                        }, <DeleteOutlined />)
                      })}
                    </div>,
                    default: () => <a-button type="dashed" shape="circle"><MoreOutlined /></a-button>
                  })}
                </span>
              </span>
            } else {
              return <span>{text}</span>
            }
          } else {
            return <span>
              <span>{text}</span>
              <span style="float: right">
                {h(Tooltip, { placement: 'top', overlayStyle: { 'z-index': 0 } }, {
                  title: () => <div>
                    {h(Tooltip, { placement: 'bottom' }, {
                      title: () => <span>{that.$t('label.workspace.set.admin')}</span>,
                      default: () => h(Button, {
                        shape: 'circle',
                        type: 'primary',
                        style: { 'margin-right': '2px' },
                        onClick: () => that.makeAdmin(record)
                      }, <TeamOutlined />)
                    })}

                    {h(Tooltip, { placement: 'bottom' }, {
                      title: () => <span>{that.$t('label.workspace.set.user')}</span>,
                      default: () => h(Button, {
                        shape: 'circle',
                        style: { 'margin-right': '2px' },
                        onClick: () => that.makeUser(record)
                      }, <UserOutlined />)
                    })}

                    {h(Tooltip, { placement: 'bottom' }, {
                      title: () => <span>{that.$t('label.workspace.set.password')}</span>,
                      default: () => h(Button, {
                        shape: 'circle',
                        style: { 'margin-right': '2px' },
                        onClick: () => that.updatePassword(record)
                      }, <KeyOutlined />)
                    })}

                    {h(Tooltip, { placement: 'bottom' }, {
                      title: () => <span>{that.$t('label.workspace.unlock.user')}</span>,
                      default: () => h(Button, {
                        shape: 'circle',
                        style: { 'margin-right': '2px' },
                        onClick: () => that.unlockUser(record)
                      }, <KeyOutlined />)
                    })}

                    {!record.workspaceApplianceUuid && h(Tooltip, { placement: 'bottom' }, {
                      title: () => <span>{that.$t('label.workspace.user.vdi.create')}</span>,
                      default: () => h(Button, {
                        shape: 'circle',
                        type: 'primary',
                        style: { 'margin-right': '2px' },
                        onClick: () => that.createVdi(record)
                      }, <DesktopOutlined />)
                    })}

                    {record.workspaceApplianceUuid && h(Tooltip, { placement: 'bottom' }, {
                      title: () => <span>{that.$t('label.workspace.user.delete')}</span>,
                      default: () => h(Button, {
                        shape: 'circle',
                        type: 'danger',
                        style: { 'margin-right': '2px' },
                        onClick: () => that.deleteVdi(record)
                      }, <DesktopOutlined />)
                    })}

                    {h(Tooltip, { placement: 'bottom' }, {
                      title: () => <span>{that.$t('label.workspace.user.simple.delete')}</span>,
                      default: () => h(Button, {
                        shape: 'circle',
                        type: 'danger',
                        style: { 'margin-right': '2px' },
                        onClick: () => that.deleteUser(record)
                      }, <DeleteOutlined />)
                    })}
                  </div>,
                  default: () => <a-button type="dashed" shape="circle"><MoreOutlined /></a-button>
                })}
              </span>
            </span>
          }
        }
      }, {
        dataIndex: 'username',
        title: this.$t('label.username')
      }, {
        dataIndex: 'email',
        title: this.$t('label.email')
      }, {
        dataIndex: 'status',
        title: this.$t('label.status'),
        customRender: function ({ text, record, index }) {
          var statusText = record.status.charAt(0).toUpperCase() + record.status.slice(1).toLowerCase()
          return <Status text={statusText}></Status>
        }
      }]
      this.initform()
      this.fetchData()
    },
    async updateUserPassword (e) {
      e.preventDefault()
      var that = this
      that.form_ref.validateFields().then(async () => {
        this.userPasswordModalVisible = false
        var baseParams = await that.getAnsibleBaseParams(that.resource)
        var user = that.update.user
        user.password = that.update.password
        that.copyObject(user, baseParams, 'user')
        var ansibleParams = that.convertNamespaces(baseParams)
        var paramBase64 = that.encodeVars(ansibleParams)

        var ansibleTask = await that.asyncApi('startAnsibleTaskAsync', { playbook: 'update-user-password', vars: paramBase64 })
        await that.waitForTask(ansibleTask.ansiblestarttaskasyncresponse.jobid, that.$t('label.workspace.update.start'), that.$t('error.fetching.async.job.result'), that.$t('label.workspace.update.end'))
        this.initform()
      }).catch(err => {
        that.form_ref.scrollToField(err.errorFields[0].name)
        if (err) {
          that.$notification.error({
            message: that.$t('message.request.failed'),
            description: that.$t('error.form.message')
          })
        }
      })
    },
    closeUserPasswordModal () {
      this.userPasswordModalVisible = false
    },
    initform () {
      this.update = reactive({})
      this.form_rules = reactive({
        password: [{ required: true, validator: this.validatePassword }],
        confirmpassword: [{ required: true, validator: this.validateConfirmPassword }]
      })
    },
    async makeAdmin (user) {
      var that = this
      this.$confirm({
        title: that.$t('label.role') + ' ' + user.name,
        content: that.$t('label.confirm.add.to.administrators'),
        onOk: function () {
          setTimeout(async function () {
            var baseParams = await that.getAnsibleBaseParams(that.resource)
            that.copyObject(user, baseParams, 'user')
            var ansibleParams = that.convertNamespaces(baseParams)
            var paramBase64 = that.encodeVars(ansibleParams)

            var ansibleTask = await that.asyncApi('startAnsibleTaskAsync', { playbook: 'update-user-administrator-role', vars: paramBase64 })
            await that.waitForTask(ansibleTask.ansiblestarttaskasyncresponse.jobid, that.$t('label.workspace.update.start'), that.$t('error.fetching.async.job.result'), that.$t('label.workspace.update.end'))
          })
        }
      })
    },
    makeUser (user) {
      var that = this
      this.$confirm({
        title: that.$t('label.role') + ' ' + user.name,
        content: that.$t('label.confirm.remove.from.administrators'),
        onOk: function () {
          setTimeout(async function () {
            var baseParams = await that.getAnsibleBaseParams(that.resource)
            that.copyObject(user, baseParams, 'user')
            var ansibleParams = that.convertNamespaces(baseParams)
            var paramBase64 = that.encodeVars(ansibleParams)

            var ansibleTask = await that.asyncApi('startAnsibleTaskAsync', { playbook: 'update-user-basic-role', vars: paramBase64 })
            await that.waitForTask(ansibleTask.ansiblestarttaskasyncresponse.jobid, that.$t('label.workspace.update.start'), that.$t('error.fetching.async.job.result'), that.$t('label.workspace.update.end'))
          })
        }
      })
    },
    updatePassword (user) {
      this.update.user = user
      this.userPasswordModalVisible = true
    },
    unlockUser (user) {
      var that = this
      setTimeout(async function () {
        var baseParams = await that.getAnsibleBaseParams(that.resource)
        that.copyObject(user, baseParams, 'user')
        var ansibleParams = that.convertNamespaces(baseParams)
        var paramBase64 = that.encodeVars(ansibleParams)

        var ansibleTask = await that.asyncApi('startAnsibleTaskAsync', { playbook: 'unlock-ad-user', vars: paramBase64 })
        await that.waitForTask(ansibleTask.ansiblestarttaskasyncresponse.jobid, that.$t('label.workspace.update.start'), that.$t('error.fetching.async.job.result'), that.$t('label.workspace.update.end'))
      })
    },
    createVdi (user) {
      var that = this
      this.$confirm({
        title: that.$t('label.workspace.user.vdi.create') + ' ' + user.name,
        content: that.$t('label.confirm.create.user.vdi'),
        onOk: function () {
          setTimeout(async function () {
            var baseParams = await that.getAnsibleBaseParams(that.resource)
            var workspaceConfig = (await that.asyncApi('getWorkspaceConfiguration')).workspaceconfigurationresponse.payload.configuration
            that.copyObject(workspaceConfig, baseParams)
            that.copyObject(user, baseParams, 'user')
            baseParams.vdi_name = that.convertUsernameToVdiName(user.username)

            var ansibleParams = that.convertNamespaces(baseParams)
            await that.getBestServiceOfferings(ansibleParams)
            var paramBase64 = that.encodeVars(ansibleParams)

            var ansibleTask = await that.asyncApi('startAnsibleTaskAsync', { playbook: 'setup-existing-workspace-user-vdi', vars: paramBase64 })
            await that.waitForTask(ansibleTask.ansiblestarttaskasyncresponse.jobid, that.$t('label.workspace.vdi.start.setup'), that.$t('error.fetching.async.job.result'), that.$t('label.workspace.vdi.end.setup'))
            that.$emit('triggerRefresh')
          })
        }
      })
    },
    deleteVdi (user) {
      var that = this
      this.$confirm({
        title: that.$t('label.workspace.user.delete') + ' ' + user.name,
        content: that.$t('label.confirm.delete.user.vdi'),
        okType: 'danger',
        onOk: function () {
          setTimeout(async function () {
            var baseParams = await that.getAnsibleBaseParams(that.resource)
            that.copyObject(user, baseParams, 'user')
            var appliance = (await that.asyncApi('listWorkspaceAppliances', { workspace_uuid: that.resource.uuid, uuid: user.workspaceApplianceUuid })).workspaceappliancelistresponse.payload.appliances[0]
            that.copyObject(appliance, baseParams, 'user.appliance')
            var ansibleParams = that.convertNamespaces(baseParams)
            var paramBase64 = that.encodeVars(ansibleParams)

            var ansibleTask = await that.asyncApi('startAnsibleTaskAsync', { playbook: 'remove-existing-workspace-user-vdi', vars: paramBase64 })
            await that.waitForTask(ansibleTask.ansiblestarttaskasyncresponse.jobid, that.$t('label.workspace.vdi.start.remove'), that.$t('error.fetching.async.job.result'), that.$t('label.workspace.vdi.end.remove'))
            that.$emit('triggerRefresh')
          })
        }
      })
    },
    deleteUser (user) {
      var that = this
      this.$confirm({
        title: that.$t('label.delete') + ' ' + user.name,
        content: that.$t('label.confirm.delete.user'),
        okType: 'danger',
        onOk: function () {
          setTimeout(async function () {
            var baseParams = await that.getAnsibleBaseParams(that.resource)
            that.copyObject(user, baseParams, 'user')
            if (user.workspaceApplianceUuid) {
              var appliance = (await that.asyncApi('listWorkspaceAppliances', { workspace_uuid: that.resource.uuid, uuid: user.workspaceApplianceUuid })).workspaceappliancelistresponse.payload.appliances[0]
              that.copyObject(appliance, baseParams, 'user.appliance')
            }
            var ansibleParams = that.convertNamespaces(baseParams)
            var paramBase64 = that.encodeVars(ansibleParams)

            await that.asyncApi('updateWorkspaceUserStatus', { uuid: user.uuid, status: 'STOPPING' })
            that.$emit('triggerRefresh')
            var ansibleTask = null
            if (user.workspaceApplianceUuid) {
              ansibleTask = await that.asyncApi('startAnsibleTaskAsync', { playbook: 'remove-workspace-vdi', vars: paramBase64 })
            } else {
              ansibleTask = await that.asyncApi('startAnsibleTaskAsync', { playbook: 'remove-workspace-user', vars: paramBase64 })
            }
            await that.waitForTask(ansibleTask.ansiblestarttaskasyncresponse.jobid, that.$t('label.workspace.update.start'), that.$t('error.fetching.async.job.result'), that.$t('label.workspace.update.end'))
            that.$emit('triggerRefresh')
          })
        }
      })
    },
    convertUsernameToVdiName (inName) {
      var name = ''
      for (var i = 0; i < inName.length; i++) {
        var c = inName[i]
        if ((c >= 'a' && c <= 'z') || (c >= 'A' && c <= 'Z') || (c >= '0' && c <= '9') || c === '-') {
          name = name + c
        } else {
          name = name + '-'
        }
      }
      while (name[name.length - 1] === '-') {
        name = name.substr(0, name.length - 1)
      }
      if (name.length > 11) {
        name = name.substr(0, 11)
      }
      return name
    },
    async fetchData () {
      if (!this.workspaceId) return
      this.loading = true

      var listVirtualMachines = this.asyncApi('listVirtualMachines', { listall: true, filter: 'id,name' })
      var listVirtualMachinesJson = await listVirtualMachines
      if (listVirtualMachinesJson) {
        this.virtualmachines = listVirtualMachinesJson.listvirtualmachinesresponse.virtualmachine
      }
      var workspaceGetJson = await this.asyncApi('getWorkspace', { uuid: this.workspaceId })
      if (workspaceGetJson) {
        this.resource = workspaceGetJson.workspaceresponse.payload.workspaces[0]
      }

      let users = null
      if (!users) {
        var json = await this.asyncApi('listWorkspaceUsers', { workspace_uuid: this.resource.uuid })
        users = json.workspaceuserlistresponse.payload.users
      }
      this.rows.splice(0, this.rows.length)
      _.map(users, (responseItem, responseKey) => {
        this.rows[responseKey] = responseItem
      })
      this.loading = false
    },
    validatePassword (rule, value, callback) {
      var txt = value || ''
      var c = 0
      var C = 0
      var s = 0
      var d = 0
      for (var i = 0; i < txt.length; i++) {
        var chr = txt.charAt(i)
        if (chr >= 'a' && chr <= 'z') {
          c = 1
        } else if (chr >= 'A' && chr <= 'Z') {
          C = 1
        } else if (chr >= '0' && chr <= '9') {
          d = 1
        } else {
          s = 1
        }
      }

      if (txt.length < 6) {
        callback(this.$t('error.invalid.windows.password.length'))
        return
      }
      if (c + C + s + d < 4) {
        callback(this.$t('error.invalid.windows.password.strength'))
        return
      }
      callback()
    },
    validateConfirmPassword (rule, value, callback) {
      if (this.update.password !== value) {
        callback(this.$t('error.password.not.match'))
        return
      }
      callback()
    }
  }
}
</script>

<style>
.margin-right-2 {
  margin-right: 2px;
}
</style>
